const copyTitleToClipboard = (txt) => {
    try {
        // Create a temporary input element
        let tempInput = document.createElement("input");
        tempInput.type = "text";
        tempInput.value = txt;
        document.body.appendChild(tempInput);

        // Select and copy the input value to clipboard
        tempInput.select();
        document.execCommand("copy");

        // Remove the temporary input element
        document.body.removeChild(tempInput);
        return true
    } catch (e) {
        console.log(e.message);
        return false;
    }
}

export default copyTitleToClipboard;
